export type TillageApplication = {
  key?: string;
  type: string;
  endDate: string;
  cropId: string;
  assignedPracticeId: string;
  payout: number;
  year: number;
};

export type TillageHookType = {
  id: string;
  name: string;
  enabled: boolean;
  synmonyms: string[];
};

export const ENUM_TILLAGE_SOIL_MIXING_TYPE = {
  MIXING: "mixing",
  LOOSENING: "loosening",
  TURNING: "turning",
};

export type TILLAGE_SOIL_MIXING_TYPE = (typeof ENUM_TILLAGE_SOIL_MIXING_TYPE)[keyof typeof ENUM_TILLAGE_SOIL_MIXING_TYPE];
